import React from 'react';
import { InfoIcon } from 'lucide-react';
export function LegalNotice() {
  return <section aria-labelledby="aviso-importante" className="mx-auto w-full max-w-4xl px-4 pb-12 pt-4 sm:px-6 lg:px-8" data-id="element-254" data-mp="1djl4gpkzuyow">
      <div className="rounded-2xl border border-brand-blue/20 bg-white p-6 md:p-7" data-id="element-255" data-mp="1ii4sqwn28mkf">
        <h2 id="aviso-importante" className="mb-3 flex items-center gap-2 font-title text-xs font-bold tracking-[.18em] text-brand-blue md:text-sm" data-id="element-256" data-mp="1nhhj3rd54brr">
          <InfoIcon className="h-4 w-4 text-brand-goldDark" data-id="element-257" data-mp="1sgc7r9xsgujs" />
          AVISO IMPORTANTE
        </h2>
        <p className="text-[13px] leading-relaxed text-brand-textLight md:text-sm" data-id="element-258" data-mp="1wgw3c92prq3t">
          KIT MAESTRO DE BIODESCODIFICACIÓN™ es material digital de carácter educativo. Sus contenidos están
          destinados a organización, reflexión y acompañamiento dentro del alcance profesional de cada usuario. No
          constituyen diagnóstico ni tratamiento médico, psicológico o psiquiátrico y no sustituyen la atención de
          profesionales de la salud. Ante síntomas, urgencias o situaciones de riesgo corresponde consultar o derivar
          a profesionales habilitados. Los modelos de documentos incluidos son educativos y deben adaptarse a la
          legislación y a los requisitos profesionales de cada país.
        </p>
      </div>
    </section>;
}